module.exports = __webpack_public_path__ + "static/media/shapez.733464e3.gif";